import { FDC } from '../../CIMSModule/instances'
import { CIMSPageItem } from '../CIMSPageItem'
import { Disciplines, Notifications, QuickLinks } from '.'

export const FDCTracker = new CIMSPageItem({
  id: '6e450001-d8a2-4a75-87e9-e17523f3e370',
  name: 'FDC Tracker',
  pathname: 'fdc-tracker',
  module: FDC,
  linkable: true,
})
export const FDCConcurrences = new CIMSPageItem({
  id: '4e4694e1-5af8-48ff-b19f-86dd852bdbd5',
  name: 'Concurrences',
  pathname: 'concurrences',
  module: FDC,
})
export const FDCApprovalGroups = new CIMSPageItem({
  id: '20f39882-d812-44cb-b7bc-3f2b6e7f573e',
  name: 'Approval Groups',
  pathname: 'approval-groups',
  module: FDC,
})
export const FDCDisciplines = Disciplines({
  id: '3ade166b-1469-4e3b-8d77-0d68a63a6512',
  module: FDC,
})
export const FDCQuickLinks = QuickLinks({
  id: '17d3642c-fcfe-4bdd-9ffb-f9a9c90218cd',
  module: FDC,
})
export const FDCNotifications = Notifications({
  id: '1d1d26cb-e2a8-4819-9f42-efbb1b120a30',
  module: FDC,
})
export type FDCPageItem =
  | typeof FDCTracker
  | typeof FDCConcurrences
  | typeof FDCApprovalGroups
  | typeof FDCDisciplines
  | typeof FDCQuickLinks
  | typeof FDCNotifications
